module.exports = __webpack_public_path__ + "static/img/logo2.dda9045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2.png
// module id = qvJq
// module chunks = 16